export class Constants {
  public static REFRESH_TOKEN_LS = "sa_refresh_token";
}
